import { z } from 'zod';
import { emailSchema } from './signUp.js';
import { orgRoleSchema } from './team.js';
/**
 * Asking who you are.
 *
 * There is no sign-in shape here any more: signing in happens against the
 * identity provider, in its own components, and this product never sees a
 * password. What is left is the one question only this product can answer —
 * which organisation the person the provider named belongs to, and what they
 * may do in it.
 *
 * A 401 from this route means one of two things to the application: no valid
 * provider token, or a valid one for somebody with no place here yet. It does
 * not say which, because saying would tell an anonymous caller which subjects
 * exist. The application can tell them apart anyway — it knows from the
 * provider whether somebody is signed in — and shows either the sign-in screen
 * or the form that makes an organisation.
 */
/** Who the bearer token belongs to. The shape the app shell is built from. */
export const currentSessionSchema = z.object({
    email: emailSchema,
    organizationName: z.string(),
    /**
     * What this person may do inside their own organisation.
     *
     * Display only: it decides which navigation entries are worth offering, and
     * every route behind them refuses again on the server. A permission the
     * browser holds is a permission the browser can be told to hold, and hiding
     * a link has never stopped anyone typing the URL.
     */
    role: orgRoleSchema,
});
//# sourceMappingURL=session.js.map